import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LicenseUsersService } from '@portal-core/license-users/services/license-users.service';
import { Team } from '@portal-core/teams/models/team.model';
import { TeamsService } from '@portal-core/teams/services/teams.service';
import { TeamPageFilterConfig } from '@portal-core/teams/util/team-page-filter-config';
import { ListControl } from '@portal-core/ui/list/util/list-control';
import { ListBase } from '@portal-core/ui/list/util/list.base';
import { of } from 'rxjs';

@Component({
  selector: 'mc-license-user-teams-list',
  templateUrl: './license-user-teams-list.component.html',
  styleUrls: ['./license-user-teams-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LicenseUserTeamsListComponent extends ListBase<Team> implements OnChanges {
  @Input() licenseUserId: number;
  @Input() canEdit: boolean = false;

  @Output() saved: EventEmitter<void> = new EventEmitter<void>();

  removing: number[] = [];

  filterConfig: TeamPageFilterConfig = new TeamPageFilterConfig(['Name']);

  listControl: ListControl<Team> = new ListControl<Team>(this.teamsService, filter => {
    if (typeof this.licenseUserId === 'number') {
      return this.licenseUsersService.getTeams$(this.licenseUserId, filter);
    } else {
      return of(null);
    }
  });

  constructor(
    private licenseUsersService: LicenseUsersService,
    private teamsService: TeamsService,
    private snackBar: MatSnackBar,
  ) {
    super(teamsService);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.licenseUserId) {
      this.hardReload();
    }
  }

  onRemoveTeam(teamId: number) {
    this.removing = [
      ...this.removing,
      teamId
    ];
    this.teamsService.removeUserFromTeam$(this.licenseUserId, teamId).subscribe(() => {
      this.teamsService.removePagedDataListItems$(this.dataListId, [teamId]);
      this.removing = this.removing.filter(id => id !== teamId);
      this.saved.emit();
    }, error => {
      this.removing = this.removing.filter(id => id !== teamId);
      this.snackBar.open('Unable to remove the user from the team.', 'OK');
    });
  }
}
